import React from 'react';

const TextFieldInput = ({ title, value, onChange }) => (
  <div className="column">
    <div className="field">
      <div className="label">
        <label htmlFor="" className="label">
          {title}
        </label>
      </div>
      <div className="field-body">
        <div className="field is-expanded">
            <input
              className="input"
              type="search"
              placeholder=""
              onChange={onChange}
              value={value}
            />
        </div>
      </div>
    </div>
  </div>
);

export default TextFieldInput;
